// Unpublished Work © 2020-2022 Deere & Company

import t from 'tcomb';

export const Membership = t.struct({
    detailsLink: t.String,
    sourceSystemCustomerNumber: t.String,
    sourceSystemDescription: t.String,
    sourceSystemId: t.String,
    sourceSystemUnitId: t.String
}, {
    defaultProps: {
        detailsLink: '',
        sourceSystemCustomerNumber: '',
        sourceSystemDescription: '',
        sourceSystemId: '',
        sourceSystemUnitId: ''
    },
    name: 'Membership'
});

export const Memberships = t.struct({
    defaultCrossReferences: t.list(Membership),
    requestedCrossReferences: t.list(Membership)
}, {
    defaultProps: {
        defaultCrossReferences: [],
        requestedCrossReferences: []
    },
    name: 'Memberships'
});
